import DeviceInterface, {
  DevicePhasesActiveStatus,
  DeviceStatusTypes,
} from "../../interfaces/DeviceInterface";

function deviceFactory({
  id,
  type,
  groupId,
  name,
  serialNumber,
  phasesActiveStatus,
  status,
  currentlyUsed,
  maxSetCurrent,
}: {
  id: string;
  type: string;
  groupId?: string;
  name?: string;
  serialNumber: string;
  phasesActiveStatus: DevicePhasesActiveStatus;
  status: DeviceStatusTypes;
  currentlyUsed: number;
  maxSetCurrent?: number;
}): DeviceInterface {
  return Object.freeze({
    id,
    type,
    groupId,
    get name() {
      return this.hasDefaultName ? undefined : name;
    },
    get hasDefaultName() {
      return name?.trim()?.toUpperCase() === "JUICE BOOSTER 3 AIR";
    },
    serialNumber,
    status,
    phasesActiveStatus,
    currentlyUsed,
    maxSetCurrent,
  });
}

export default deviceFactory;
